var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-modal',{ref:"Modal",attrs:{"buttons":_vm.buttons,"loading":_vm.loading,"title":"Assinatura eletrônica","extraLarge":""},on:{"save":function($event){return _vm.$refs.Form.handleAssinatura()}}},[_c('Form',{ref:"Form",attrs:{"item":_vm.item},on:{"handleShowSave":_vm.handleShowSave,"save":_vm.handleExit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }